export const THEME_COLOR = "#31accd";
export const DARK_MAIN = "#040404";
export const SECONDARY_MAIN = "#686666";
export const GREEN = "#198754";
export const RED = "#dc3545";
export const DARK_TEAL = "#008388";
export const AMBER_YELLOW = "#ffc107";